import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { TituloReceberFormModule } from '../titulo-receber-form.module';

import { TituloReceberFormModalComponent } from './titulo-receber-form-modal.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberFormModule
    ],
    declarations: [
        TituloReceberFormModalComponent
    ],
    exports: [
        TituloReceberFormModalComponent
    ]
})
export class TituloReceberFormModalModule {}
